var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.33 3.882A2 2 0 0 0 9.333 2H4l-.118.003A2 2 0 0 0 2 4v5.333l.003.118A2 2 0 0 0 4 11.333h.667V12a2 2 0 0 0 2 2H12a2 2 0 0 0 2-2V6.667a2 2 0 0 0-2-2h-.667V4l-.003-.118ZM10 4.667V4a.667.667 0 0 0-.589-.662l-.078-.005H4a.667.667 0 0 0-.662.59L3.333 4v5.333c0 .342.258.624.59.663L4 10h.667V6.667a2 2 0 0 1 2-2H10Zm-4 6V12c0 .368.298.667.667.667H12a.667.667 0 0 0 .667-.667V6.667A.667.667 0 0 0 12 6H6.667A.667.667 0 0 0 6 6.667v4Z",
    fill: "#059669"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.3b556a00e808ef7cbc7d22e74f275cc0.svg";
export { ForwardRef as ReactComponent };